module.exports = __webpack_public_path__ + "1ed43d61ffec8e638e7be584e8952ccd.png";